import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Twitter } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white" data-testid="main-footer">
      <div className="container mx-auto px-4 py-12" style={{marginTop: '60px'}}>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4">
              <img
                src="./media/logos/logo-dark.png"
                alt="DeltaOpsAI Logo"
                className="h-8 w-8 mr-2 inline-block"
              />
              DeltaOps<span className="text-cyan-300">AI</span>
            </h3>
            <p className="text-gray-400 mb-4">
              AI-powered healthcare flow optimization for better patient outcomes and operational efficiency.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://www.linkedin.com/company/deltaops-ai"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-cyan-300 transition-colors"
                aria-label="LinkedIn"
                data-testid="footer-linkedin"
              >
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/success-stories"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Success Stories
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/operations-flow"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Operations Flow
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-gray-400 hover:text-white transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Solutions */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Solutions</h4>
            <ul className="space-y-2 text-gray-400">
              <li>Caregiver Matching</li>
              <li>Real-Time Coordination</li>
              <li>AI-driven Forecasting</li>
              <li>Dynamic Staff Deployment</li>
              <li>Resource Efficiency</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Mail size={20} className="text-cyan-300 mt-1 flex-shrink-0" />
                <a
                  href="mailto:info@deltaops.health"
                  className="text-gray-400 hover:text-white transition-colors"
                  data-testid="footer-email"
                >
                  hi@deltaops.health
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin size={20} className="text-cyan-300 mt-1 flex-shrink-0" />
                <span className="text-gray-400">
                  West Lafayette, IN
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; {currentYear} DeltaOps AI. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
